import React, { useState } from 'react';
import { Fragment, useEffect } from 'react';
import { useSelector, useDispatch, getAllProducts } from '../../imports/generalImport';
import { Container } from '../../imports/muiImport';
import { Helmet } from 'react-helmet-async';
import GiftCardSkeleton from './GiftCardSkeleton';
import CategorySection from './CategorySection';
import { SliderComponent } from '../../components/SliderComponent';
import FoodGiftCard from '../../components/foodgiftcard/foodgiftcoponent';
import FashionFlexComponent from '../../components/fashionflex/fashionflexcomponent';
import SpecailDiscountComponent from '../../components/specailDiscount/specailDiscountGiftcard';
import GiftSectionComponent from '../../components/giftcardSections/gift-section.component';
import OurClientsection from './Ourclientsection';
import { fetchDashboardData } from '../../store/dashboard/action';
import NavbarSearch from '../../layouts/innerComponent/NavbarSearch';
import { Box } from '@mui/system';
import { v4 as uuidv4 } from "uuid";
import { jwtDecode } from "jwt-decode";


const canonicalUrl = `https://www.99gift.ae`;

const MemoizedGiftSection = React.memo(
  ({ data, title, categoriesData }) => (
    <Container maxWidth="xl" sx={{ mb: 3 }} disableGutters>
      {(data?.data?.length || categoriesData?.length) ? (
        <GiftSectionComponent
          key={`id-${uuidv4()}`}
          sectionTitle={title}
          sectionData={data?.data}
          categoriesData={categoriesData}
        />
      ) : (
        <GiftCardSkeleton key={`id-${uuidv4()}`} />
      )}
    </Container>
  )
);

const Homepage = () => {
  const dispatch = useDispatch();
  const [jewelleryAPIData, setJewelleryAPIData] = useState([]);
  const [groceryAPIData, setGroceryAPIData] = useState([]);
  const [travelAPIData, setTravelAPIData] = useState([]);

  // gaming
  const EntertaintmentAPI = async () => {
    try {
      const payload = {
        "categoryIds[]": "e55c20bb-7e79-42a8-8bd7-d46fc97bd793",
        limit: 10,
      };
      const res = await getAllProducts(payload);
      if (res.status) {
        setGroceryAPIData(res.data?.edges);
      } else {
        setGroceryAPIData({ error: true });
      }
    } catch (error) {

    }
  }

  const ApprealAPI = async () => {
    try {
      const payload = {
        "categoryIds[]": "d9617f26-72b9-4674-9f52-2b78883e835a",
        limit: 10,
      };
      const res = await getAllProducts(payload);
      if (res.status) {
        setJewelleryAPIData(res.data?.edges);
      } else {
        setJewelleryAPIData({ error: true });
      }
    } catch (error) {

    }
  }
  const FootwearAPI = async () => {
    try {
      const payload = {
        "categoryIds[]": "acdfff8a-5095-445e-afb8-c1cc32d9fdaf",
        limit: 10,
      };
      const res = await getAllProducts(payload);
      if (res.status) {
        setTravelAPIData(res.data?.edges);
      } else {
        setTravelAPIData({ error: true });
      }
    } catch (error) {

    }
  }
  // Select all data in one selector to reduce re-renders
  const dashboardData = useSelector((state) => ({
    mostSelling: state?.Dashboard?.mostSellingProducts,
    topPickForYou: state?.Dashboard?.topPickProducts,
    grocery: state?.Dashboard?.Grocery,
    jewellery: state?.Dashboard?.Jewellery,
    travel: state?.Dashboard?.Travel,
    isLoading: state?.Dashboard?.isLoading,
    lastFetchedAt: state?.Dashboard?.lastFetchedAt
  }));



  useEffect(() => {
    dispatch(fetchDashboardData());
    ApprealAPI();
    EntertaintmentAPI();
    FootwearAPI();
  }, [dispatch]);

  return (
    <Fragment>
      <HomepageSeo />
      <Container
        maxWidth="xl"
        disableGutters
      >



        <Box sx={{
          display: {
            xs: "block",
            md: "none",
          },
          width: "100%",
          mx: { xs: 0, md: 2.5  },


        }}>
          <NavbarSearch />
        </Box>


        <SliderComponent />
        <CategorySection />

        <OurClientsection
          data={[
            ...(dashboardData?.topPickForYou?.data || []),
            ...(dashboardData?.mostSelling?.data || [])
          ]}
        />

        {/* TOP PICK */}
        <MemoizedGiftSection
          data={dashboardData?.topPickForYou}
          title={dashboardData?.topPickForYou?.title}
        />


        {/* FOOD GIFT CARD */}
        <Box
          sx={{
            display: {
              xs: "none",
              sm: "block",
            },
          }}
        >
          <FoodGiftCard />
        </Box>
        {/* MOST SELLING */}
        <MemoizedGiftSection
          data={dashboardData?.mostSelling}
          title={dashboardData?.mostSelling?.title}
        />


        {/* FASHION FLEX */}
        <FashionFlexComponent />

        {/* SPECIAL DISCOUNT */}
        <SpecailDiscountComponent />





        {/* Entertaintment*/}
        <MemoizedGiftSection
          categoriesData={groceryAPIData}
          title={"Entertaintment gift cards"}
        />

        {/* footwear */}
        <MemoizedGiftSection
          categoriesData={travelAPIData}
          title={"Footwear gift cards"}
        />


        {/* Appreal */}
        <MemoizedGiftSection
          categoriesData={jewelleryAPIData}
          title={"Appreal gift cards"}
        />




      </Container>
    </Fragment>
  );
};

export default React.memo(Homepage);

const HomepageSeo = () => {
  return (
    <Helmet>
      <title>Buy Digital Gift Cards Online in UAE | Instant Delivery – 99gift.ae</title>
      <meta
        name="description"
        content="Buy digital gift cards online in the UAE with instant email delivery. Perfect for birthdays, Eid & corporate gifting. Secure payments. Trusted brands."
      />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content="99Gift - 200+ Brands Discount Gift Vouchers Online" />
      <meta
        property="og:description"
        content="99Gift offers a wide variety of discounted gift cards for over 250 brands in India, including Apparels, eCommerce, Entertainment, Travels, Food, Entertainment, Grocery, Mobile, Footwear Etc. You can also find E-Gift cards for personal and commercial use"
      />
      <link rel="canonical" href={canonicalUrl} />
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'http://schema.org',
          '@type': 'Organization',
          name: '99gift',
          description:
            "Welcome to 99gift.ae, your ultimate destination for Gift Cards and Gift Vouchers in India! Whether you're looking to Buy Gift Cards Online or find the best Discount Gift Cards, we have you covered. Explore a wide variety of e-gift cards India and enjoy exciting gift card offers on top brands like Myntra, Nykaa, and more. Get your favorite gift card at a discount and shop Gift Cards with ease. At 99gift, we offer the best gift card deals and gift card discounts to make gifting simple and affordable. Buy discounted gift cards today and discover why 99gift is the top choice for Gift Card Online India!",
          url: 'https://www.99gift.ae/',
          sameAs: [
            'https://www.facebook.com/99gift.ae',
            'https://www.linkedin.com/company/99-gift/',
            'https://www.instagram.com/99gift.ae/',
            'https://www.99gift.ae/blog',
            'https://play.google.com/store/apps/details?id=in.nngift.vouchers&hl=en&gl=US',
            'https://apps.apple.com/in/app/99gift/id1645057090',
            'https://www.youtube.com/@99gift',
          ],
          logo: 'https://www.99gift.ae/static/media/logo.1f56873eb49af1faa202.png',
          address: {
            '@type': 'PostalAddress',
            streetAddress:
              '511 Alankar Plaza, CENTRAL SPINE-3, Sector 2, Central Spine, Vidyadhar Nagar',
            addressLocality: 'Jaipur',
            addressRegion: 'Rajasthan',
            postalCode: '302039',
            addressCountry: 'IN',
          },
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'Customer Support',
            // telephone: '+9718742998998',
            email: 'support@99gift.ae',
          },
          foundingDate: '2019',
          parentOrganization: 'ZPAY SOLUTIONS PVT LTD',
          founder: {
            '@type': 'Person',
            name: 'Jitesh Agarwal',
          },
          location: {
            '@type': 'Place',
            name: '99gift',
            address: {
              '@type': 'PostalAddress',
              streetAddress:
                '511 Alankar Plaza, CENTRAL SPINE-3, Sector 2, Central Spine, Vidyadhar Nagar',
              addressLocality: 'Jaipur',
              addressRegion: 'Rajasthan',
              postalCode: '302039',
              addressCountry: 'IN',
            },
          },
          areaServed: {
            '@type': 'Place',
            name: 'India',
          },
          knowsAbout: [
            'Gift Cards',
            'Gift Vouchers',
            'Gift Card Online',
            'eVouchers',
            'Corporate Gift Cards',
            'Digital Payments',
            'Gaming Gift Cards',
            'Shopping Vouchers',
            'Personalized Gifting',
            'E-gift cards',
          ],
        })}
      </script>
    </Helmet>
  );
};
